import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
// import isAuthenticated from '../utils/auth'
import { Menu, Image, Icon, Popup } from 'semantic-ui-react'
import isAuthenticated from '../../utils/auth'
import {
  VAULTURE_USER_AVATAR_KEY,
} from '../../utils/constants'
import { observer } from '../../stores'
import UserMenuModal from './UserMenu'
import { useTranslation } from 'react-i18next'

interface UserMenuProps {
  trigger: React.ReactNode
  onOpenSettings: () => void
}

const UserMenu = observer((props: UserMenuProps) => {
  const history = useHistory()
  const { t } = useTranslation()

  console.warn(history)

  return (
    <Popup trigger={props.trigger} hoverable basic position="bottom right">
      <Menu secondary vertical>
        <Menu.Item name="browse" onClick={props.onOpenSettings}>
          <Icon name="globe" />
          Language / 语言
        </Menu.Item>
        <Menu.Item name="messages" onClick={() => {history.push('/logout')}}>
          <Icon name="sign out" />
          {t('logOut')}
        </Menu.Item>
        {/* 
        <Dropdown item text="More">
          <Dropdown.Menu>
            <Dropdown.Item icon="edit" text="Edit Profile" />
            <Dropdown.Item icon="globe" text="Choose Language" />
            <Dropdown.Item icon="settings" text="Account Settings" />
          </Dropdown.Menu>
        </Dropdown> */}
      </Menu>
    </Popup>
  )
})

const Header = observer(() => {
  const [activeItem] = useState<string>('home')

  const [settingsOpen, setSettingsOpen] = useState(false)

  // const handleItemClick = (_: any, { name }: any) => setActiveItem(name)

  if (!isAuthenticated()) return <></>

  return (
    <>
      <br />
      <UserMenuModal isOpen={settingsOpen} onClose={() => setSettingsOpen(false)}/>
      <Menu secondary>
        <Menu.Menu>
          <img src="logo2.png" alt="logo" width="65" height="50" />
        </Menu.Menu>
        <Menu.Menu position="right">
          {/* <Menu.Item>
            <FileSearch />
          </Menu.Item> */}
          <Menu.Item name="logout" active={activeItem === 'logout'}>
            <UserMenu
              trigger={
                <div style={{ marginRight: '10px' }}>
                  <Image
                    src={localStorage.getItem(VAULTURE_USER_AVATAR_KEY)}
                    size="mini"
                    circular
                  />
                </div>
              }
              onOpenSettings={() => setSettingsOpen(true)}
            />
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    </>
  )
})

export default Header
